
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("f3rHG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("f6Gkc")).default);

var $f6Gkc = parcelRequire("f6Gkc");


var $9z044 = parcelRequire("9z044");


var $IF0hr = parcelRequire("IF0hr");


var $6KjXa = parcelRequire("6KjXa");


var $4APPq = parcelRequire("4APPq");

$parcel$exportWildcard(module.exports, $f6Gkc);
$parcel$exportWildcard(module.exports, $9z044);
$parcel$exportWildcard(module.exports, $IF0hr);
$parcel$exportWildcard(module.exports, $6KjXa);
$parcel$exportWildcard(module.exports, $4APPq);

});

parcelRegister("533k0", function(module, exports) {

var $3PAnx = parcelRequire("3PAnx");


var $fh4WQ = parcelRequire("fh4WQ");


var $hWvFC = parcelRequire("hWvFC");

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $3acfcf32bba54b31$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $hWvFC(iteratee, 3);
    $fh4WQ(object, function(value, key, object) {
        $3PAnx(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $3acfcf32bba54b31$var$mapValues;

});

parcelRegister("fh4WQ", function(module, exports) {

var $9d5GH = parcelRequire("9d5GH");


var $d6TaN = parcelRequire("d6TaN");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $b1ec481d92afa1cf$var$baseForOwn(object, iteratee) {
    return object && $9d5GH(object, iteratee, $d6TaN);
}
module.exports = $b1ec481d92afa1cf$var$baseForOwn;

});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("iawSg", function(module, exports) {

var $fh4WQ = parcelRequire("fh4WQ");


var $fKRi0 = parcelRequire("fKRi0");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $d3a2a94fdae59b54$var$baseEach = $fKRi0($fh4WQ);
module.exports = $d3a2a94fdae59b54$var$baseEach;

});

parcelRegister("fKRi0", function(module, exports) {

var $bRRFB = parcelRequire("bRRFB");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $b7847d143ef17a3d$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$bRRFB(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $b7847d143ef17a3d$var$createBaseEach;

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("f6Gkc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $aff83f5a247def7b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "envTypes", () => (parcelRequire("9ElVX")).envTypes);

var $hXuPC = parcelRequire("hXuPC");


var $lgmus = parcelRequire("lgmus");





var $5vbNx = parcelRequire("5vbNx");

var $db23421b8350e240$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["OFFLINE"] = 0] = "OFFLINE";
    NetworkStatus[NetworkStatus["ONLINE"] = 1] = "ONLINE";
})($db23421b8350e240$export$bd096ddbd246c79c || ($db23421b8350e240$export$bd096ddbd246c79c = {}));



var $81a93f76ee664498$var$Network = /** @class */ function() {
    function Network(_a) {
        var _this = this;
        var onOnlineCallback = _a.onOnlineCallback;
        this.networkStatus = (0, $db23421b8350e240$export$bd096ddbd246c79c).ONLINE;
        window.addEventListener('offline', function() {
            _this.networkStatus = (0, $db23421b8350e240$export$bd096ddbd246c79c).OFFLINE;
        });
        window.addEventListener('online', function() {
            _this.networkStatus = (0, $db23421b8350e240$export$bd096ddbd246c79c).ONLINE;
            onOnlineCallback();
        });
    }
    Object.defineProperty(Network.prototype, "status", {
        get: function() {
            // if ('onLine' in navigator) {
            //   return navigator.onLine ? NetworkStatus.ONLINE : NetworkStatus.OFFLINE;
            // }
            return this.networkStatus;
        },
        enumerable: false,
        configurable: true
    });
    return Network;
}();
var $81a93f76ee664498$export$2e2bcd8739ae039 = $81a93f76ee664498$var$Network;


var $82f390fa62d21308$var$promisifiedBeacon = function(url, blob) {
    return new Promise(function(resolve, reject) {
        try {
            var status_1 = navigator.sendBeacon(url, blob);
            if (status_1) resolve(status_1);
            else reject(status_1);
        } catch (e) {
            console.warn('MetalSender: sendBeacon failure');
        }
    });
};
var $82f390fa62d21308$var$promisifiedXHR = function(url, body) {
    return new Promise(function(resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', url);
        xhr.setRequestHeader('Content-Type', 'text/plain');
        xhr.send(body);
        xhr.onerror = reject;
        xhr.onload = resolve;
        xhr.ontimeout = resolve;
    });
};
/**
 * Responsible for sending metric, log.. etc payloads
 * Configured by MetalClient directly
 */ var $82f390fa62d21308$var$Sender = /** @class */ function() {
    function Sender(_a) {
        var url = _a.url, meta = _a.meta, metalId = _a.metalId, synthetic = _a.synthetic, _b = _a.forceXHR, forceXHR = _b === void 0 ? false : _b;
        /**
     * Time between network retries
     */ this.retryInterval = 30000;
        /**
     * buffer to hold things that fail due to network connectivity
     */ this.buffer = [];
        /**
     * Favor using XHR over Beacon API
     */ this.forceXHR = false;
        this.url = url;
        this.meta = meta;
        this.metalId = metalId;
        this.forceXHR = forceXHR;
        this.network = new (0, $81a93f76ee664498$export$2e2bcd8739ae039)({
            onOnlineCallback: this.restartSending.bind(this)
        });
        this.sendData = this.sendData.bind(this);
        this.synthetic = synthetic;
    }
    Sender.prototype.updateMeta = function(meta) {
        this.meta = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this.meta), meta);
    };
    Sender.prototype.restartSending = function() {
        var _this = this;
        this.buffer.forEach(function(payload) {
            return _this.sendData(payload);
        });
        this.buffer = [];
    };
    Sender.prototype.sendBeacon = function(blob) {
        return $82f390fa62d21308$var$promisifiedBeacon(this.url, blob);
    };
    Sender.prototype.sendXHR = function(type, data, retries) {
        var _this = this;
        if (retries === void 0) retries = 1;
        return $82f390fa62d21308$var$promisifiedXHR(this.url, data).catch(function() {
            if (retries < 3) {
                var retryIn = retries * _this.retryInterval;
                console.warn("MetalSender: Receiver not responding, will retry in " + Math.floor(retryIn / 1000) + "s");
                setTimeout(function() {
                    return _this.sendXHR(type, data, retries + 1);
                }, retryIn);
            } else console.warn("MetalSender: Max retries reached, payload (" + type + ") failed to send");
        });
    };
    Sender.prototype.sendData = function(_a) {
        var type = _a.type, data = _a.data;
        if (this.network.status === (0, $db23421b8350e240$export$bd096ddbd246c79c).OFFLINE) {
            this.buffer.push({
                type: type,
                data: data
            });
            return Promise.resolve(null);
        }
        var metalId = this.metalId;
        var meta = (0, $5vbNx.objectValuesToString)(this.meta);
        var body = (0, $hXuPC.__assign)({
            type: type,
            meta: meta,
            metalId: metalId,
            data: data
        }, this.synthetic !== undefined ? {
            synthetic: String(this.synthetic)
        } : {});
        if (!navigator.sendBeacon || this.forceXHR) return this.sendXHR(type, JSON.stringify(body));
        var headers = {
            type: 'application/json'
        };
        var blob = new Blob([
            JSON.stringify(body)
        ], headers);
        return this.sendBeacon(blob);
    };
    /**
   * This is the public facing API for the sender; although this function
   * is intended for internal consumption by the MetalCore Classes.
   *
   * @param buffer {T[]}    An array of payload body type
   * @param type   {T}      A type of MetalCore eg, 'log', 'metric', etc...
   * @param meta   {object} Any additional meta info for this payload (global meta info)
   */ Sender.prototype.send = function(buffer, type) {
        if (buffer === void 0) buffer = [];
        if (buffer.length < 1) return;
        this.sendData({
            type: type,
            data: buffer
        }).catch(function(e) {
            // Catch rejection or any potential exceptions surfaced from promise.
            // e.g. Safari AdBlock is blocking access to metal and incurs a
            // promise rejection in promisifiedBeacon
            console.warn('MetalSender: sendData failure:', e);
        });
    };
    return Sender;
}();
var $82f390fa62d21308$export$2e2bcd8739ae039 = $82f390fa62d21308$var$Sender;



var $b1W9o = parcelRequire("b1W9o");


var $a82vj = parcelRequire("a82vj");

parcelRequire("6KjXa");
var $5azij = parcelRequire("5azij");


var $7ECiZ = parcelRequire("7ECiZ");




var $a50543d73b4b4233$var$_a, $a50543d73b4b4233$var$_b, $a50543d73b4b4233$var$_c;
var $a50543d73b4b4233$var$BROWSER_MAP = (0, (/*@__PURE__*/$parcel$interopDefault($7ECiZ))).BROWSER_MAP, $a50543d73b4b4233$var$OS_MAP = (0, (/*@__PURE__*/$parcel$interopDefault($7ECiZ))).OS_MAP, $a50543d73b4b4233$var$PLATFORMS_MAP = (0, (/*@__PURE__*/$parcel$interopDefault($7ECiZ))).PLATFORMS_MAP;
// Whitelists loosely against constant values from 'bowser' ~ 2.5.2
// https://github.com/lancedikson/bowser/blob/master/src/constants.js
var $a50543d73b4b4233$var$browser = ($a50543d73b4b4233$var$_a = {}, $a50543d73b4b4233$var$_a[$a50543d73b4b4233$var$BROWSER_MAP.chrome] = 'chrome', $a50543d73b4b4233$var$_a[$a50543d73b4b4233$var$BROWSER_MAP.chromium] = 'chromium', $a50543d73b4b4233$var$_a[$a50543d73b4b4233$var$BROWSER_MAP.safari] = 'safari', $a50543d73b4b4233$var$_a[$a50543d73b4b4233$var$BROWSER_MAP.firefox] = 'firefox', $a50543d73b4b4233$var$_a[$a50543d73b4b4233$var$BROWSER_MAP.edge] = 'edge', $a50543d73b4b4233$var$_a[$a50543d73b4b4233$var$BROWSER_MAP.ie] = 'ie', $a50543d73b4b4233$var$_a);
var $a50543d73b4b4233$var$platform = ($a50543d73b4b4233$var$_b = {}, $a50543d73b4b4233$var$_b[$a50543d73b4b4233$var$PLATFORMS_MAP.desktop] = 'desktop', $a50543d73b4b4233$var$_b[$a50543d73b4b4233$var$PLATFORMS_MAP.mobile] = 'mobile', $a50543d73b4b4233$var$_b);
var $a50543d73b4b4233$var$os = ($a50543d73b4b4233$var$_c = {}, $a50543d73b4b4233$var$_c[$a50543d73b4b4233$var$OS_MAP.MacOS] = 'macos', $a50543d73b4b4233$var$_c[$a50543d73b4b4233$var$OS_MAP.Linux] = 'linux', $a50543d73b4b4233$var$_c[$a50543d73b4b4233$var$OS_MAP.Windows] = 'windows', $a50543d73b4b4233$var$_c[$a50543d73b4b4233$var$OS_MAP.iOS] = 'ios', $a50543d73b4b4233$var$_c[$a50543d73b4b4233$var$OS_MAP.Android] = 'android', $a50543d73b4b4233$var$_c);
var $a50543d73b4b4233$var$whitelists = {
    browser: $a50543d73b4b4233$var$browser,
    os: $a50543d73b4b4233$var$os,
    platform: $a50543d73b4b4233$var$platform
};
var $a50543d73b4b4233$export$2e2bcd8739ae039 = $a50543d73b4b4233$var$whitelists;


function $109fecee95536eff$export$2e2bcd8739ae039(_a) {
    var _b = (_a === void 0 ? {} : _a).userAgentString, userAgentString = _b === void 0 ? window.navigator.userAgent : _b;
    var rawBrowserInfo = (0, (/*@__PURE__*/$parcel$interopDefault($7ECiZ))).getParser(userAgentString);
    var os = (0, $a50543d73b4b4233$export$2e2bcd8739ae039).os[rawBrowserInfo.getOSName()] || 'other';
    var platform = (0, $a50543d73b4b4233$export$2e2bcd8739ae039).platform[rawBrowserInfo.getPlatformType()] || 'other';
    var browser = (0, $a50543d73b4b4233$export$2e2bcd8739ae039).browser[rawBrowserInfo.getBrowserName()] || 'other';
    return {
        os: os,
        platform: platform,
        browser: browser
    };
}


var $2fe6dd862ffc6533$export$bc6b8fc5a64fb2d = function() {
    var doc = document;
    var hiddenInfo = {
        isHidden: false,
        hidden: 'undefined',
        visibilityChange: 'undefined'
    };
    if (typeof doc.hidden !== 'undefined') {
        // Opera 12.10 and Firefox 18 and later support
        hiddenInfo.isHidden = doc.hidden;
        hiddenInfo.hidden = 'hidden';
        hiddenInfo.visibilityChange = 'visibilitychange';
    } else if (typeof doc.msHidden !== 'undefined') {
        hiddenInfo.isHidden = doc.msHidden;
        hiddenInfo.hidden = 'msHidden';
        hiddenInfo.visibilityChange = 'msvisibilitychange';
    } else if (typeof doc.webkitHidden !== 'undefined') {
        hiddenInfo.isHidden = doc.webkitHidden;
        hiddenInfo.hidden = 'webkitHidden';
        hiddenInfo.visibilityChange = 'webkitvisibilitychange';
    }
    return hiddenInfo;
};


var $429d6ca4608ba0e8$var$PageVisibility = /** @class */ function() {
    function PageVisibility() {
        var _this = this;
        this.callbacks = new Map();
        this.lastHiddenAt = 0;
        this.bindEventListeners = function() {
            document.addEventListener(_this.visibilityChange, _this.handleVisibilityChange, false);
        };
        this.handleVisibilityChange = function() {
            var isHidden = document[_this.hidden];
            _this.documentHiddenInfo.isHidden = isHidden;
            if (isHidden) _this.lastHiddenAt = performance.now();
            if (!_this.wasPreviouslyHidden) _this.wasPreviouslyHidden = isHidden;
            _this.callbacks.forEach(function(callbackFn) {
                return callbackFn(isHidden);
            });
        };
        this.documentHiddenInfo = (0, $2fe6dd862ffc6533$export$bc6b8fc5a64fb2d)();
        this.wasPreviouslyHidden = this.documentHiddenInfo.isHidden;
        if (typeof document.addEventListener !== 'undefined' && this.hidden !== undefined) this.bindEventListeners();
    }
    PageVisibility.prototype.addCallback = function(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this.callbacks.set(name, fn);
    };
    PageVisibility.prototype.removeCallback = function(name) {
        if (this.callbacks.has(name)) this.callbacks.delete(name);
    };
    Object.defineProperty(PageVisibility.prototype, "isHidden", {
        get: function() {
            return this.documentHiddenInfo.isHidden;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageVisibility.prototype, "hidden", {
        get: function() {
            return this.documentHiddenInfo.hidden;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageVisibility.prototype, "visibilityChange", {
        get: function() {
            return this.documentHiddenInfo.visibilityChange;
        },
        enumerable: false,
        configurable: true
    });
    return PageVisibility;
}();
var $429d6ca4608ba0e8$export$2e2bcd8739ae039 = $429d6ca4608ba0e8$var$PageVisibility;


var $2781862ac07c53c0$var$defaultGetPageFn = function() {
    return '';
};
var $2781862ac07c53c0$var$PageTracker = /** @class */ function() {
    function PageTracker(getPage) {
        if (getPage === void 0) getPage = $2781862ac07c53c0$var$defaultGetPageFn;
        this.initialPage = '';
        this.initialPage = getPage();
        this.getPage = getPage;
    }
    Object.defineProperty(PageTracker.prototype, "page", {
        get: function() {
            if (this.getPage) {
                var page = this.getPage();
                if (!this.initialPage) this.initialPage = page;
                return page;
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    return PageTracker;
}();
var $2781862ac07c53c0$export$2e2bcd8739ae039 = $2781862ac07c53c0$var$PageTracker;



var $9z044 = parcelRequire("9z044");




var $c713dc7f2b04f34f$var$config = {
    api: {
        local: 'https://api.stg.atlassian.com/metal/ingest',
        dev: 'https://api.stg.atlassian.com/metal/ingest',
        staging: 'https://api.stg.atlassian.com/metal/ingest',
        prod: 'https://api.atlassian.com/metal/ingest'
    }
};
var $c713dc7f2b04f34f$export$2e2bcd8739ae039 = $c713dc7f2b04f34f$var$config;









var $9ElVX = parcelRequire("9ElVX");

var $14bf636b2da9c3be$export$fd35ff7210c560be = function(productInfo) {
    if (!productInfo.metalId) throw new Error('Missing metalId');
    if (!productInfo) throw new Error('Missing productInfo');
    if (!productInfo.env) throw new Error('Missing productInfo.env');
    if (!productInfo.version) throw new Error('Missing productInfo.version');
    if (!(0, $5vbNx.isType)((0, $9ElVX.envTypes), productInfo.env)) throw new Error("Invalid productInfo.env '" + productInfo.env + "', must be an envType: [" + (0, $5vbNx.objectValues)((0, $9ElVX.envTypes)) + "]");
};
var $14bf636b2da9c3be$export$ba41f44c61addf37 = function() {
    var _a;
    return _a = {}, _a[(0, $9z044.CoreType).METRIC] = [], _a[(0, $9z044.CoreType).ERROR] = [], _a;
};


var $3a0dbe29f5b65366$exports = {};





var $aff83f5a247def7b$var$defaultSettings = {
    getPage: function() {
        return '';
    },
    metrics: {
        flushInterval: 1000,
        maxBufferSize: 10,
        sampleRate: 1,
        bufferType: (0, $9z044.CoreType).METRIC
    }
};
var $aff83f5a247def7b$var$MetalClient = /** @class */ function() {
    function MetalClient(_a) {
        var _this = this;
        var productInfo = _a.productInfo, _b = _a.settings, settings = _b === void 0 ? $aff83f5a247def7b$var$defaultSettings : _b, _c = _a.plugins, plugins = _c === void 0 ? [] : _c, _d = _a.forceXHR, forceXHR = _d === void 0 ? false : _d;
        /**
     * Internal hooks being used by Metal and responding to certain MetalEvents
     */ this.hooks = (0, $14bf636b2da9c3be$export$ba41f44c61addf37)();
        (0, $14bf636b2da9c3be$export$fd35ff7210c560be)(productInfo);
        var mergedSettings = (0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))($aff83f5a247def7b$var$defaultSettings, settings, {
            metrics: {
                meta: settings.meta
            }
        });
        this.productInfo = productInfo;
        var version = productInfo.version, metalId = productInfo.metalId, env = productInfo.env;
        this.meta = (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, settings.meta), {
            version: version,
            env: env
        }), (0, $109fecee95536eff$export$2e2bcd8739ae039)());
        this.sender = new (0, $82f390fa62d21308$export$2e2bcd8739ae039)({
            url: (0, $c713dc7f2b04f34f$export$2e2bcd8739ae039).api[env],
            metalId: metalId,
            meta: this.meta,
            synthetic: settings.synthetic,
            forceXHR: forceXHR
        });
        this.pageVisibility = new (0, $429d6ca4608ba0e8$export$2e2bcd8739ae039)();
        this.pageTracker = new (0, $2781862ac07c53c0$export$2e2bcd8739ae039)(mergedSettings.getPage);
        // create the unified hook
        var hook = this.onSend.bind(this);
        this.metric = new (0, $b1W9o.default)({
            sender: this.sender,
            settings: mergedSettings.metrics,
            hook: hook,
            pageVisibility: this.pageVisibility
        });
        this.error = new (0, $a82vj.default)({
            hook: hook
        });
        this.updateSettings = this.updateSettings.bind(this);
        /**
     * Plugins are installed if an array is passed to Metal,
     * else by default we instantiate the default set of plugins.
     */ var defaultPlugins = [
            new (0, $5azij.default)()
        ];
        this.plugins = (0, $hXuPC.__spread)(defaultPlugins, plugins);
        this.plugins.forEach(function(plugin) {
            return plugin.install(_this);
        });
    }
    /**
   * Merges an object of new settings with the current settings.
   * @param newSettings The new settings object
   */ MetalClient.prototype.updateSettings = function(newSettings) {
        if (newSettings.meta) {
            this.meta = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this.meta), newSettings.meta);
            this.sender.updateMeta(this.meta);
        }
        if (newSettings.metrics) this.metric.updateSettings(newSettings.metrics);
    };
    Object.defineProperty(MetalClient.prototype, "initialPage", {
        get: function() {
            return this.pageTracker.initialPage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MetalClient.prototype, "currentPage", {
        get: function() {
            return this.pageTracker.page;
        },
        enumerable: false,
        configurable: true
    });
    // public interface to add a hook
    MetalClient.prototype.addEventHook = function(type, callback) {
        if (!(0, $5vbNx.isType)((0, $9z044.CoreType), type)) throw new Error("Invalid hook, must be a CoreType [" + (0, $5vbNx.objectValues)((0, $9z044.CoreType)) + "]");
        this.hooks[type].push(callback);
    };
    MetalClient.prototype.destroy = function() {
        // Destroy plugins
        this.plugins.forEach(function(plugin) {
            return plugin.destroy && plugin.destroy();
        });
    };
    // internal hook
    MetalClient.prototype.onSend = function(_a) {
        var _this = this;
        var type = _a.type, data = _a.data;
        this.hooks[type].forEach(function(callback) {
            return callback(data, _this.meta);
        });
    };
    return MetalClient;
}();
var $aff83f5a247def7b$export$2e2bcd8739ae039 = $aff83f5a247def7b$var$MetalClient;
$parcel$exportWildcard(module.exports, $3a0dbe29f5b65366$exports);

});

parcelRegister("9z044", function(module, exports) {
$parcel$export(module.exports, "CoreType", () => $6f676eccae566655$export$6b816263e18b80f1);
/**
 * Parts of the MetalCore
 */ 
var $a82vj = parcelRequire("a82vj");


var $b1W9o = parcelRequire("b1W9o");

var $6f676eccae566655$export$6b816263e18b80f1;
(function(CoreType) {
    CoreType["METRIC"] = "metric";
    CoreType["ERROR"] = "error";
})($6f676eccae566655$export$6b816263e18b80f1 || ($6f676eccae566655$export$6b816263e18b80f1 = {}));
$parcel$exportWildcard(module.exports, $a82vj);
$parcel$exportWildcard(module.exports, $b1W9o);

});

parcelRegister("fTVVJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b938edc60aee0aa3$export$2e2bcd8739ae039);


var $b938edc60aee0aa3$var$Hookable = /** @class */ function() {
    function Hookable(_a) {
        var hook = _a.hook;
        this.hook = hook;
    }
    return Hookable;
}();
var $b938edc60aee0aa3$export$2e2bcd8739ae039 = $b938edc60aee0aa3$var$Hookable;

});

parcelRegister("l8YuP", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");

var $f64945a335b40a96$export$4c601f98f6476fcc = /** @class */ function() {
    function CallbackProvider(_a) {
        var _b = _a.callbacks, callbacks = _b === void 0 ? [] : _b;
        this.callbacks = [];
        // ensure we create a new array
        this.callbacks = callbacks.map(function(callback) {
            return callback;
        });
    }
    CallbackProvider.prototype.doCallbacks = function() {
        var data = [];
        for(var _i = 0; _i < arguments.length; _i++)data[_i] = arguments[_i];
        this.callbacks.forEach(function(cb) {
            return cb.apply(void 0, (0, $hXuPC.__spread)(data));
        });
    };
    return CallbackProvider;
}();
var $f64945a335b40a96$export$2e2bcd8739ae039 = $f64945a335b40a96$export$4c601f98f6476fcc;
module.exports["default"] = $f64945a335b40a96$export$2e2bcd8739ae039;

});

parcelRegister("Weaan", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "PaintMetricsPlugin", () => (parcelRequire("bZz6J")).default);
$parcel$export(module.exports, "InteractiveMetricsPlugin", () => (parcelRequire("cOeoN")).default);
$parcel$export(module.exports, "ResourceMetricsPlugin", () => (parcelRequire("fO1NJ")).default);
parcelRequire("lmw9L");

parcelRequire("8bjcg");
var $h8UsG = parcelRequire("h8UsG");


var $bZz6J = parcelRequire("bZz6J");


var $cOeoN = parcelRequire("cOeoN");


var $fO1NJ = parcelRequire("fO1NJ");

/**
 * Wrapper class to simplify api.
 */ var $0af0675dc059b1c8$export$2e2bcd8739ae039 = /** @class */ function() {
    function BrowserMetricsPlugin(_a) {
        var rootId = _a.rootId, _b = _a.callbacks, callbacks = _b === void 0 ? [] : _b, _c = _a.collectors, collectors = _c === void 0 ? {} : _c, _d = _a.histograms, histograms = _d === void 0 ? {} : _d, _e = _a.blacklist, blacklist = _e === void 0 ? [] : _e;
        if (!rootId) throw new Error((0, $h8UsG).errors.metrics.browser.rootId);
        this.interactiveMetrics = new (0, $cOeoN.default)({
            callbacks: callbacks,
            collectors: collectors,
            histograms: histograms
        });
        this.paintMetrics = new (0, $bZz6J.default)({
            rootId: rootId,
            callbacks: callbacks,
            collectors: collectors,
            histograms: histograms
        });
        this.resourceMetrics = new (0, $fO1NJ.default)({
            callbacks: callbacks,
            blacklist: blacklist
        });
        this.plugins = [
            this.interactiveMetrics,
            this.paintMetrics,
            this.resourceMetrics
        ];
    }
    BrowserMetricsPlugin.prototype.install = function(client) {
        this.plugins.forEach(function(plugin) {
            return plugin.install(client);
        });
    };
    BrowserMetricsPlugin.prototype.destroy = function() {
        this.plugins.forEach(function(plugin) {
            return plugin.destroy && plugin.destroy();
        });
    };
    return BrowserMetricsPlugin;
}();
module.exports["default"] = $0af0675dc059b1c8$export$2e2bcd8739ae039;

});

parcelRegister("5azij", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $9z044 = parcelRequire("9z044");

/**
 * ErrorsPlugin automatically hooks into
 * a call to MetalClient.error.submit() and counts it as metric error count
 */ var $3c3943ab40e563d4$var$ErrorsPlugin = /** @class */ function() {
    function ErrorsPlugin() {}
    ErrorsPlugin.prototype.install = function(client) {
        // Listen to error events from MetalClient
        client.addEventHook((0, $9z044.CoreType).ERROR, function(_a) {
            var page = _a.page, component = _a.component, name = _a.name;
            client.metric.submit((0, $hXuPC.__assign)({
                name: name,
                value: 1,
                page: page
            }, component ? {
                component: component
            } : {}));
        });
    };
    return ErrorsPlugin;
}();
var $3c3943ab40e563d4$export$2e2bcd8739ae039 = $3c3943ab40e563d4$var$ErrorsPlugin;
module.exports["default"] = $3c3943ab40e563d4$export$2e2bcd8739ae039;

});

parcelRegister("bjxrB", function(module, exports) {

var $9z044 = parcelRequire("9z044");


var $5vbNx = parcelRequire("5vbNx");

/**
 * DevTools plugin observes calls to any MetalCore hook
 * and reports its result.
 *
 * Useful for verifying local development behaviour of MetalClient.
 */ var $83cb6967d3e3ecf6$var$DevToolsPlugin = /** @class */ function() {
    function DevToolsPlugin() {
        /* eslint-disable no-console */ this.printError = function(error) {
            console.group("METAL " + (0, $9z044.CoreType).ERROR);
            console.table(error);
            console.groupEnd();
        };
        /* eslint-enable no-console */ /* eslint-disable no-console */ this.printMetric = function(metric) {
            console.group("METAL " + (0, $9z044.CoreType).METRIC + " (" + metric.type + ")");
            console.table({
                name: metric.name,
                value: metric.value,
                tags: metric.tags ? metric.tags.toString() : null
            });
            console.groupEnd();
        };
    /* eslint-enable no-console */ }
    DevToolsPlugin.prototype.install = function(client) {
        var _a;
        // Listen to all events from MetalClient
        var typeMap = (_a = {}, _a[(0, $9z044.CoreType).ERROR] = this.printError, _a[(0, $9z044.CoreType).METRIC] = this.printMetric, _a);
        (0, $5vbNx.objectValues)((0, $9z044.CoreType)).forEach(function(type) {
            client.addEventHook(type, function(data) {
                if (typeMap[type]) typeMap[type](data);
            });
        });
    };
    return DevToolsPlugin;
}();
var $83cb6967d3e3ecf6$export$2e2bcd8739ae039 = $83cb6967d3e3ecf6$var$DevToolsPlugin;
module.exports["default"] = $83cb6967d3e3ecf6$export$2e2bcd8739ae039;

});

parcelRegister("dc4A7", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $k7lsW = parcelRequire("k7lsW");

/**
 * Will pull any performance marks or measures that the user specifies
 * and send them to SFX based on a user defined mapping
 */ var $99aff3294f6e0895$var$PerformanceMarkPlugin = /** @class */ function() {
    function PerformanceMarkPlugin(userDefinedAllowlist) {
        var _this = this;
        this.allowlist = {};
        if (!(0, $k7lsW.isPerformanceObserverSupported)()) {
            console.warn('Metal: Performance Observer not supported, PerformanceMarkPlugin will not work');
            return;
        }
        Object.keys(userDefinedAllowlist).forEach(function(metricName) {
            var markItem = userDefinedAllowlist[metricName];
            if (!metricName) throw new Error('Metal: Unsupported metric type supplied to PerformanceMarkPlugin');
            _this.allowlist[markItem.name] = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, markItem), {
                name: metricName
            });
        });
        this.observer = new PerformanceObserver(this.getMarksCallback.bind(this));
        this.observer.observe({
            entryTypes: [
                'mark',
                'measure'
            ]
        });
    }
    PerformanceMarkPlugin.prototype.getMarksCallback = function(list) {
        var _this = this;
        list.getEntries().forEach(function(entry) {
            if (entry.name in _this.allowlist) {
                var markPayload = _this.allowlist[entry.name];
                var value = entry.duration ? entry.duration : entry.startTime;
                _this.client.metric.submit((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, markPayload), {
                    value: value
                }));
            }
        });
    };
    PerformanceMarkPlugin.prototype.install = function(client) {
        this.client = client;
    };
    PerformanceMarkPlugin.prototype.destroy = function() {
        if (this.observer) this.observer.disconnect();
    };
    return PerformanceMarkPlugin;
}();
var $99aff3294f6e0895$export$2e2bcd8739ae039 = $99aff3294f6e0895$var$PerformanceMarkPlugin;
module.exports["default"] = $99aff3294f6e0895$export$2e2bcd8739ae039;

});

parcelRegister("4APPq", function(module, exports) {

var $lmw9L = parcelRequire("lmw9L");

var $3582ba41e2fec32d$export$b42865bafc072eab = {
    error: (0, $lmw9L.ErrorMetricName),
    performance: (0, $lmw9L.PerformanceMetricName),
    userInteraction: (0, $lmw9L.UserInteractionMetricName)
};
module.exports["catalog"] = $3582ba41e2fec32d$export$b42865bafc072eab;

});

parcelRegister("b1W9o", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $807ce52b287a163d$export$2e2bcd8739ae039);

var $hXuPC = parcelRequire("hXuPC");


var $fTVVJ = parcelRequire("fTVVJ");




var $6eda883373375065$var$Queue = /** @class */ function() {
    function Queue(settings, callback) {
        var _this = this;
        this.buffer = [];
        this.settings = settings;
        this.callback = callback;
        this.intervalHandle = setInterval(this.flush.bind(this), this.settings.flushInterval);
        window.addEventListener('beforeunload', function() {
            if (_this.intervalHandle) clearInterval(_this.intervalHandle);
        });
    }
    Queue.prototype.flush = function() {
        this.callback(this.buffer, this.settings.bufferType);
        // TODO: there is potential data loss here if the send call fails
        // FIX ME Probably handle in sender tho.
        this.buffer = [];
    };
    Queue.prototype.enqueue = function(payload) {
        this.buffer.push(payload);
        var maxBufferSize = this.settings.maxBufferSize;
        if (maxBufferSize > 0 && this.buffer.length >= maxBufferSize) this.flush();
    };
    Queue.prototype.updateSettings = function(newSettings) {
        this.settings = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this.settings), newSettings);
        if (newSettings.flushInterval) {
            clearInterval(this.intervalHandle);
            this.intervalHandle = setInterval(this.flush.bind(this), newSettings.flushInterval);
        }
    };
    return Queue;
}();
var $6eda883373375065$export$2e2bcd8739ae039 = $6eda883373375065$var$Queue;



var $9z044 = parcelRequire("9z044");


var $5vbNx = parcelRequire("5vbNx");





var $lmw9L = parcelRequire("lmw9L");


var $lPHtt = parcelRequire("lPHtt");

var $fb2f7ba82253736b$var$_a, $fb2f7ba82253736b$var$_b;
var $fb2f7ba82253736b$export$51f1d0967a29b999 = ($fb2f7ba82253736b$var$_a = {}, $fb2f7ba82253736b$var$_a[(0, $lmw9L.ErrorMetricName).UNCAUGHT] = (0, $lPHtt.PayloadType).INCREMENT, $fb2f7ba82253736b$var$_a[(0, $lmw9L.ErrorMetricName).REQUEST] = (0, $lPHtt.PayloadType).INCREMENT, $fb2f7ba82253736b$var$_a[(0, $lmw9L.ErrorMetricName).API] = (0, $lPHtt.PayloadType).INCREMENT, $fb2f7ba82253736b$var$_a[(0, $lmw9L.ErrorMetricName).GRAPHQL] = (0, $lPHtt.PayloadType).INCREMENT, $fb2f7ba82253736b$var$_a[(0, $lmw9L.ErrorMetricName).VALIDATION] = (0, $lPHtt.PayloadType).INCREMENT, $fb2f7ba82253736b$var$_a[(0, $lmw9L.ErrorMetricName).INPUT] = (0, $lPHtt.PayloadType).INCREMENT, $fb2f7ba82253736b$var$_a[(0, $lmw9L.ErrorMetricName).UNHANDLED_PROMISE_REJECTION] = (0, $lPHtt.PayloadType).INCREMENT, $fb2f7ba82253736b$var$_a[(0, $lmw9L.ErrorMetricName).COMPONENT] = (0, $lPHtt.PayloadType).INCREMENT, $fb2f7ba82253736b$var$_a[(0, $lmw9L.ErrorMetricName).COMPONENT_BOUNDARY] = (0, $lPHtt.PayloadType).INCREMENT, $fb2f7ba82253736b$var$_a[(0, $lmw9L.ErrorMetricName).COMPONENT_GRAPHQL] = (0, $lPHtt.PayloadType).INCREMENT, $fb2f7ba82253736b$var$_a[(0, $lmw9L.ErrorMetricName).COMPONENT_API] = (0, $lPHtt.PayloadType).INCREMENT, $fb2f7ba82253736b$var$_a[(0, $lmw9L.PerformanceMetricName).APDEX] = (0, $lPHtt.PayloadType).TIMING, $fb2f7ba82253736b$var$_a[(0, $lmw9L.PerformanceMetricName).SPEED_INDEX] = (0, $lPHtt.PayloadType).TIMING, $fb2f7ba82253736b$var$_a[(0, $lmw9L.PerformanceMetricName).TIME_TO_INTERACTIVE] = (0, $lPHtt.PayloadType).TIMING, $fb2f7ba82253736b$var$_a[(0, $lmw9L.PerformanceMetricName).TIME_TO_INTERACTIVE_SLO] = (0, $lPHtt.PayloadType).INCREMENT, $fb2f7ba82253736b$var$_a[(0, $lmw9L.PerformanceMetricName).TIME_TO_FIRST_BYTE] = (0, $lPHtt.PayloadType).TIMING, $fb2f7ba82253736b$var$_a[(0, $lmw9L.PerformanceMetricName).FIRST_PAINT] = (0, $lPHtt.PayloadType).TIMING, $fb2f7ba82253736b$var$_a[(0, $lmw9L.PerformanceMetricName).FIRST_CONTENTFUL_PAINT] = (0, $lPHtt.PayloadType).TIMING, $fb2f7ba82253736b$var$_a[(0, $lmw9L.PerformanceMetricName).FIRST_MEANINGFUL_PAINT] = (0, $lPHtt.PayloadType).TIMING, $fb2f7ba82253736b$var$_a[(0, $lmw9L.PerformanceMetricName).FIRST_MEANINGFUL_PAINT_SLO] = (0, $lPHtt.PayloadType).INCREMENT, $fb2f7ba82253736b$var$_a[(0, $lmw9L.PerformanceMetricName).FIRST_INPUT_DELAY] = (0, $lPHtt.PayloadType).TIMING, $fb2f7ba82253736b$var$_a[(0, $lmw9L.PerformanceMetricName).REQUEST_TIMING] = (0, $lPHtt.PayloadType).TIMING, $fb2f7ba82253736b$var$_a[(0, $lmw9L.PerformanceMetricName).REQUEST_TIMING_SLO] = (0, $lPHtt.PayloadType).INCREMENT, $fb2f7ba82253736b$var$_a[(0, $lmw9L.PerformanceMetricName).RESOURCE_TIMING] = (0, $lPHtt.PayloadType).TIMING, $fb2f7ba82253736b$var$_a[(0, $lmw9L.PerformanceMetricName).CACHE_HITS] = (0, $lPHtt.PayloadType).INCREMENT, $fb2f7ba82253736b$var$_a[(0, $lmw9L.PerformanceMetricName).COMPONENT_PREVIEW] = (0, $lPHtt.PayloadType).TIMING, $fb2f7ba82253736b$var$_a[(0, $lmw9L.PerformanceMetricName).COMPONENT_INTERACTIVE] = (0, $lPHtt.PayloadType).TIMING, $fb2f7ba82253736b$var$_a[(0, $lmw9L.PerformanceMetricName).COMPONENT_READY] = (0, $lPHtt.PayloadType).TIMING, $fb2f7ba82253736b$var$_a[(0, $lmw9L.PerformanceMetricName).COMPONENT_READY_SLO] = (0, $lPHtt.PayloadType).INCREMENT, $fb2f7ba82253736b$var$_a[(0, $lmw9L.PerformanceMetricName).COMPONENT_REQUEST_TIMING] = (0, $lPHtt.PayloadType).TIMING, $fb2f7ba82253736b$var$_a[(0, $lmw9L.UserInteractionMetricName).TASK_SUCCESS] = (0, $lPHtt.PayloadType).INCREMENT, $fb2f7ba82253736b$var$_a[(0, $lmw9L.UserInteractionMetricName).TASK_FAILURE] = (0, $lPHtt.PayloadType).INCREMENT, $fb2f7ba82253736b$var$_a[(0, $lmw9L.UserInteractionMetricName).TASK_DURATION] = (0, $lPHtt.PayloadType).TIMING, $fb2f7ba82253736b$var$_a[(0, $lmw9L.UserInteractionMetricName).TASK_TIME_TO_FEEDBACK] = (0, $lPHtt.PayloadType).TIMING, $fb2f7ba82253736b$var$_a[(0, $lmw9L.UserInteractionMetricName).TASK_TIME_TO_FEEDBACK_SLO] = (0, $lPHtt.PayloadType).INCREMENT, $fb2f7ba82253736b$var$_a[(0, $lmw9L.UserInteractionMetricName).TASK_TIME_TO_COMPLETE] = (0, $lPHtt.PayloadType).TIMING, $fb2f7ba82253736b$var$_a[(0, $lmw9L.UserInteractionMetricName).TASK_TIME_TO_COMPLETE_SLO] = (0, $lPHtt.PayloadType).INCREMENT, $fb2f7ba82253736b$var$_a);
var $fb2f7ba82253736b$export$6bb99562353b405 = {
    component: 'component',
    isActiveTab: 'active_tab',
    isInitial: 'initial_load',
    isSSR: 'ssr',
    page: 'page',
    success: 'success',
    task: 'task',
    taskId: 'task_id',
    type: 'type',
    histogramBuckets: 'gsd_histogram'
};
var $fb2f7ba82253736b$var$alwaysRequired = [
    'page'
];
var $fb2f7ba82253736b$var$alwaysOptional = [
    'isSSR',
    'isActiveTab'
];
var $fb2f7ba82253736b$var$timersAlwaysOptional = [
    'histogramBuckets'
];
var $fb2f7ba82253736b$var$defaultRequirements = {
    required: (0, $hXuPC.__spread)($fb2f7ba82253736b$var$alwaysRequired),
    optional: (0, $hXuPC.__spread)($fb2f7ba82253736b$var$alwaysOptional)
};
var $fb2f7ba82253736b$var$defaultPerfRequirements = {
    required: (0, $hXuPC.__spread)($fb2f7ba82253736b$var$alwaysRequired),
    optional: (0, $hXuPC.__spread)($fb2f7ba82253736b$var$alwaysOptional, $fb2f7ba82253736b$var$timersAlwaysOptional)
};
var $fb2f7ba82253736b$var$defaultSLORequirements = {
    required: (0, $hXuPC.__spread)($fb2f7ba82253736b$var$alwaysRequired, [
        'success'
    ]),
    optional: (0, $hXuPC.__spread)($fb2f7ba82253736b$var$alwaysOptional)
};
var $fb2f7ba82253736b$var$defaultComponentRequirements = {
    required: (0, $hXuPC.__spread)($fb2f7ba82253736b$var$alwaysRequired, [
        'component'
    ]),
    optional: (0, $hXuPC.__spread)($fb2f7ba82253736b$var$alwaysOptional)
};
var $fb2f7ba82253736b$var$defaultComponentPerfRequirements = {
    required: (0, $hXuPC.__spread)($fb2f7ba82253736b$var$alwaysRequired, [
        'component'
    ]),
    optional: (0, $hXuPC.__spread)($fb2f7ba82253736b$var$alwaysOptional, $fb2f7ba82253736b$var$timersAlwaysOptional)
};
var $fb2f7ba82253736b$var$defaultTaskRequirements = {
    required: (0, $hXuPC.__spread)($fb2f7ba82253736b$var$alwaysRequired, [
        'task'
    ]),
    optional: (0, $hXuPC.__spread)($fb2f7ba82253736b$var$alwaysOptional, [
        'taskId'
    ])
};
var $fb2f7ba82253736b$var$defaultTaskPerfRequirements = {
    required: (0, $hXuPC.__spread)($fb2f7ba82253736b$var$alwaysRequired, [
        'task'
    ]),
    optional: (0, $hXuPC.__spread)($fb2f7ba82253736b$var$alwaysOptional, $fb2f7ba82253736b$var$timersAlwaysOptional, [
        'taskId'
    ])
};
var $fb2f7ba82253736b$export$476fa67b19c4e3b3 = ($fb2f7ba82253736b$var$_b = {}, // Errors
$fb2f7ba82253736b$var$_b[(0, $lmw9L.ErrorMetricName).UNCAUGHT] = $fb2f7ba82253736b$var$defaultRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.ErrorMetricName).REQUEST] = $fb2f7ba82253736b$var$defaultRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.ErrorMetricName).API] = $fb2f7ba82253736b$var$defaultRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.ErrorMetricName).GRAPHQL] = $fb2f7ba82253736b$var$defaultRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.ErrorMetricName).VALIDATION] = $fb2f7ba82253736b$var$defaultRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.ErrorMetricName).INPUT] = $fb2f7ba82253736b$var$defaultRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.ErrorMetricName).UNHANDLED_PROMISE_REJECTION] = $fb2f7ba82253736b$var$defaultRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.ErrorMetricName).COMPONENT] = $fb2f7ba82253736b$var$defaultComponentRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.ErrorMetricName).COMPONENT_BOUNDARY] = $fb2f7ba82253736b$var$defaultComponentRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.ErrorMetricName).COMPONENT_GRAPHQL] = $fb2f7ba82253736b$var$defaultComponentRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.ErrorMetricName).COMPONENT_API] = $fb2f7ba82253736b$var$defaultComponentRequirements, // Page Performance
$fb2f7ba82253736b$var$_b[(0, $lmw9L.PerformanceMetricName).APDEX] = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, $fb2f7ba82253736b$var$defaultRequirements), {
    optional: (0, $hXuPC.__spread)($fb2f7ba82253736b$var$alwaysOptional, $fb2f7ba82253736b$var$timersAlwaysOptional, [
        'isInitial'
    ])
}), $fb2f7ba82253736b$var$_b[(0, $lmw9L.PerformanceMetricName).SPEED_INDEX] = $fb2f7ba82253736b$var$defaultPerfRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.PerformanceMetricName).TIME_TO_INTERACTIVE] = $fb2f7ba82253736b$var$defaultPerfRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.PerformanceMetricName).TIME_TO_INTERACTIVE_SLO] = $fb2f7ba82253736b$var$defaultSLORequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.PerformanceMetricName).TIME_TO_FIRST_BYTE] = $fb2f7ba82253736b$var$defaultPerfRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.PerformanceMetricName).FIRST_PAINT] = $fb2f7ba82253736b$var$defaultPerfRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.PerformanceMetricName).FIRST_CONTENTFUL_PAINT] = $fb2f7ba82253736b$var$defaultPerfRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.PerformanceMetricName).FIRST_MEANINGFUL_PAINT] = $fb2f7ba82253736b$var$defaultPerfRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.PerformanceMetricName).FIRST_MEANINGFUL_PAINT_SLO] = $fb2f7ba82253736b$var$defaultSLORequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.PerformanceMetricName).FIRST_INPUT_DELAY] = $fb2f7ba82253736b$var$defaultPerfRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.PerformanceMetricName).REQUEST_TIMING] = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, $fb2f7ba82253736b$var$defaultPerfRequirements), {
    optional: (0, $hXuPC.__spread)($fb2f7ba82253736b$var$alwaysOptional, $fb2f7ba82253736b$var$timersAlwaysOptional, [
        'type'
    ])
}), $fb2f7ba82253736b$var$_b[(0, $lmw9L.PerformanceMetricName).REQUEST_TIMING_SLO] = {
    required: (0, $hXuPC.__spread)($fb2f7ba82253736b$var$alwaysRequired, [
        'success'
    ]),
    optional: (0, $hXuPC.__spread)($fb2f7ba82253736b$var$alwaysOptional, [
        'type'
    ])
}, $fb2f7ba82253736b$var$_b[(0, $lmw9L.PerformanceMetricName).RESOURCE_TIMING] = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, $fb2f7ba82253736b$var$defaultPerfRequirements), {
    optional: (0, $hXuPC.__spread)($fb2f7ba82253736b$var$alwaysOptional, $fb2f7ba82253736b$var$timersAlwaysOptional, [
        'type'
    ])
}), $fb2f7ba82253736b$var$_b[(0, $lmw9L.PerformanceMetricName).CACHE_HITS] = $fb2f7ba82253736b$var$defaultRequirements, // Component Performance
$fb2f7ba82253736b$var$_b[(0, $lmw9L.PerformanceMetricName).COMPONENT_PREVIEW] = $fb2f7ba82253736b$var$defaultComponentPerfRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.PerformanceMetricName).COMPONENT_INTERACTIVE] = $fb2f7ba82253736b$var$defaultComponentPerfRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.PerformanceMetricName).COMPONENT_REQUEST_TIMING] = $fb2f7ba82253736b$var$defaultComponentPerfRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.PerformanceMetricName).COMPONENT_READY] = $fb2f7ba82253736b$var$defaultComponentPerfRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.PerformanceMetricName).COMPONENT_READY_SLO] = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, $fb2f7ba82253736b$var$defaultRequirements), {
    required: (0, $hXuPC.__spread)($fb2f7ba82253736b$var$alwaysRequired, [
        'component',
        'success'
    ])
}), // User Interaction (Tasks)
$fb2f7ba82253736b$var$_b[(0, $lmw9L.UserInteractionMetricName).TASK_SUCCESS] = $fb2f7ba82253736b$var$defaultTaskRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.UserInteractionMetricName).TASK_FAILURE] = $fb2f7ba82253736b$var$defaultTaskRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.UserInteractionMetricName).TASK_DURATION] = $fb2f7ba82253736b$var$defaultTaskPerfRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.UserInteractionMetricName).TASK_TIME_TO_FEEDBACK] = $fb2f7ba82253736b$var$defaultTaskPerfRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.UserInteractionMetricName).TASK_TIME_TO_FEEDBACK_SLO] = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, $fb2f7ba82253736b$var$defaultTaskRequirements), {
    required: (0, $hXuPC.__spread)($fb2f7ba82253736b$var$alwaysRequired, [
        'task',
        'success'
    ])
}), $fb2f7ba82253736b$var$_b[(0, $lmw9L.UserInteractionMetricName).TASK_TIME_TO_COMPLETE] = $fb2f7ba82253736b$var$defaultTaskPerfRequirements, $fb2f7ba82253736b$var$_b[(0, $lmw9L.UserInteractionMetricName).TASK_TIME_TO_COMPLETE_SLO] = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, $fb2f7ba82253736b$var$defaultTaskRequirements), {
    required: (0, $hXuPC.__spread)($fb2f7ba82253736b$var$alwaysRequired, [
        'task',
        'success'
    ])
}), $fb2f7ba82253736b$var$_b);





var $807ce52b287a163d$var$defaultSettings = {
    sampleRate: 1,
    maxBufferSize: 10,
    flushInterval: 1000
};
/**
 * Used by MetalClient to send Metrics
 *
 * Can be instantiated seperatedly if you also provide an instance of MetalSender.
 * Includes the following public methods.
 *
 * @method increment
 * @method decrement
 * @method timing
 * @method gauge
 *
 * @see Sender
 * @see MetalClient
 */ var $807ce52b287a163d$var$assertHasValue = function(metric) {
    if (metric.value === undefined) throw new Error("Missing value for metric " + metric.name);
    if (typeof metric.value !== 'number') throw new Error("Value for metric " + metric.name + " is of type " + typeof metric.value + " and not a number");
};
// Note: we are allowing values of 0 to be submitted
// Reference: https://github.com/brightcove/hot-shots/blob/master/lib/statsFunctions.js#L110
var $807ce52b287a163d$var$valueOrDefault = function(metric, defaultValue) {
    return metric.value === undefined || typeof metric.value !== 'number' ? defaultValue : metric.value;
};
var $807ce52b287a163d$var$MetricModel = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(MetricModel, _super);
    function MetricModel(_a) {
        var sender = _a.sender, _b = _a.settings, settings = _b === void 0 ? $807ce52b287a163d$var$defaultSettings : _b, hook = _a.hook, pageVisibility = _a.pageVisibility;
        var _this = _super.call(this, {
            hook: hook
        }) || this;
        _this.sampleRate = settings.sampleRate;
        _this.queue = new (0, $6eda883373375065$export$2e2bcd8739ae039)(settings, sender.send.bind(sender));
        _this.pageVisibility = pageVisibility;
        return _this;
    }
    MetricModel.prototype.updateSettings = function(newSettings) {
        this.queue.updateSettings(newSettings);
    };
    MetricModel.prototype.increment = function(metric) {
        metric.value = $807ce52b287a163d$var$valueOrDefault(metric, 1);
        this.queue.enqueue(this.constructMetric(metric, (0, $lPHtt.PayloadType).INCREMENT));
    };
    MetricModel.prototype.decrement = function(metric) {
        metric.value = $807ce52b287a163d$var$valueOrDefault(metric, -1);
        this.queue.enqueue(this.constructMetric(metric, (0, $lPHtt.PayloadType).DECREMENT));
    };
    MetricModel.prototype.timing = function(metric) {
        $807ce52b287a163d$var$assertHasValue(metric);
        this.queue.enqueue(this.constructMetric(metric, (0, $lPHtt.PayloadType).TIMING));
    };
    MetricModel.prototype.gauge = function(metric) {
        $807ce52b287a163d$var$assertHasValue(metric);
        this.queue.enqueue(this.constructMetric(metric, (0, $lPHtt.PayloadType).GAUGE));
    };
    /**
   * Called by user directly as a manual entrypoint
   *
   * @param {UserMetric} metric The metadata required to send a configured metric
   */ MetricModel.prototype.submit = function(metric) {
        if (!(0, $5vbNx.hasKey)((0, $fb2f7ba82253736b$export$51f1d0967a29b999), metric.name)) throw new Error('Invalid Metric provided to Metal');
        var tags = [];
        (0, $5vbNx.objectKeys)((0, $fb2f7ba82253736b$export$6bb99562353b405)).forEach(function(key) {
            if ((0, $5vbNx.hasKey)(metric, key)) {
                var metricObj = metric;
                if (key === 'histogramBuckets') {
                    var isBucketFormatRegex = /^([\d+]_?)*\d+$/;
                    if (metric.histogramBuckets && !isBucketFormatRegex.test(metric.histogramBuckets) || !metric.histogramBuckets) throw new Error('Invalid Metric value: histogramBuckets');
                }
                tags.push((0, $fb2f7ba82253736b$export$6bb99562353b405)[key] + ":" + metricObj[key]);
            }
        });
        var required = (0, $fb2f7ba82253736b$export$476fa67b19c4e3b3)[metric.name].required;
        required.forEach(function(key) {
            if (!(0, $5vbNx.hasKey)(metric, key)) throw new Error("Required metric attribute " + key + " is missing");
        });
        var name = metric.name, value = metric.value;
        var method = (0, $fb2f7ba82253736b$export$51f1d0967a29b999)[name];
        this[method]({
            name: name,
            value: value,
            tags: tags
        });
    };
    MetricModel.prototype.constructMetric = function(_a, type) {
        var name = _a.name, value = _a.value, _b = _a.tags, tags = _b === void 0 ? [] : _b;
        var data = {
            type: type,
            name: name,
            tags: tags,
            value: value,
            sampleRate: this.sampleRate
        };
        // hook call to MetalClient callbacks
        this.hook({
            type: (0, $9z044.CoreType).METRIC,
            data: data
        });
        return data;
    };
    return MetricModel;
}((0, $fTVVJ.default));
var $807ce52b287a163d$export$2e2bcd8739ae039 = $807ce52b287a163d$var$MetricModel;
$parcel$exportWildcard(module.exports, $lPHtt);

});

parcelRegister("6KjXa", function(module, exports) {
$parcel$export(module.exports, "ErrorsPlugin", () => (parcelRequire("5azij")).default);
$parcel$export(module.exports, "BrowserMetricsPlugin", () => (parcelRequire("Weaan")).default);
$parcel$export(module.exports, "DevToolsPlugin", () => (parcelRequire("bjxrB")).default);
$parcel$export(module.exports, "PerformanceMarkPlugin", () => (parcelRequire("dc4A7")).default);

var $Weaan = parcelRequire("Weaan");


var $5azij = parcelRequire("5azij");


var $bjxrB = parcelRequire("bjxrB");


var $dc4A7 = parcelRequire("dc4A7");


var $gjsoz = parcelRequire("gjsoz");

$parcel$exportWildcard(module.exports, $Weaan);
$parcel$exportWildcard(module.exports, $gjsoz);

});

parcelRegister("7ECiZ", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = r(18), i = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                        return e.map(n.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                    return n;
                }, e.find = function(e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, n = e.length; r < n; r += 1){
                        var i = e[r];
                        if (t(i, r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var t, r, n = e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function() {
                        var e = s[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            n[t] = e[t];
                        });
                    };
                    for(t = 0, r = s.length; t < r; t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = i, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            function a(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            var o = function() {
                function e() {}
                var t, r, n;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, t = e, n = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, n && a(t, n), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (i[t] = a, s += 1) : "object" == typeof a && (r[t] = a, n += 1);
                    }), n > 0) {
                        var a = Object.keys(r), u = o.default.find(a, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(i), h = o.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(i[h]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(i, r, n)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(t, e),
                            version: i.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});

});

parcelRegister("9ElVX", function(module, exports) {
var $7068dd0e35e2fce5$export$a9d74288f660fcc0 = {
    LOCAL: 'local',
    DEV: 'dev',
    STAGING: 'staging',
    PROD: 'prod'
};
module.exports["envTypes"] = $7068dd0e35e2fce5$export$a9d74288f660fcc0;

});

parcelRegister("a82vj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $75fc97fa9d79bcd0$export$2e2bcd8739ae039);

var $hXuPC = parcelRequire("hXuPC");


var $fTVVJ = parcelRequire("fTVVJ");


var $9z044 = parcelRequire("9z044");


var $5wdgJ = parcelRequire("5wdgJ");

/**
 * Used from instances of MetalClient to submit errors.
 * - Sends a metric based on the scope of error
 * - Can/Will also be responsible for RavenJS in future.
 *
 * @method submit
 *
 */ var $75fc97fa9d79bcd0$var$ErrorModel = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(ErrorModel, _super);
    function ErrorModel(_a) {
        var hook = _a.hook;
        return _super.call(this, {
            hook: hook
        }) || this;
    }
    ErrorModel.prototype.submit = function(error) {
        this.hook({
            type: (0, $9z044.CoreType).ERROR,
            data: error
        });
    };
    return ErrorModel;
}((0, $fTVVJ.default));
var $75fc97fa9d79bcd0$export$2e2bcd8739ae039 = $75fc97fa9d79bcd0$var$ErrorModel;
$parcel$exportWildcard(module.exports, $5wdgJ);

});

parcelRegister("bZz6J", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $hQNhB = parcelRequire("hQNhB");

parcelRequire("IF0hr");
var $l8YuP = parcelRequire("l8YuP");


var $lmw9L = parcelRequire("lmw9L");


var $j9jqV = parcelRequire("j9jqV");


var $cVO5G = parcelRequire("cVO5G");







parcelRequire("8bjcg");
var $h8UsG = parcelRequire("h8UsG");

/**
 * PerformanceEntry => Metric
 * @param entry {PerformanceEntry}
 */ var $6511cc6d783471a6$var$normaliseData = function(_a) {
    var name = _a.name, startTime = _a.startTime;
    return {
        name: (0, $j9jqV.BROWSER_METRICS_MAP)[name],
        value: startTime
    };
};
var $6511cc6d783471a6$var$normalisePaintPerformanceEntries = function(list) {
    return (0, $hXuPC.__spread)(list).map($6511cc6d783471a6$var$normaliseData);
};
// hang on to this guy;
var $6511cc6d783471a6$var$paintPerformanceObserverPromise;
/**
 * TODO REWORK to deal with non compatible browsers
 *
 * This function needs to be super safe to work properly.
 *
 * 1. There's a chance the paint entries already exist by the time the script runs;
 *    in this case -- just use the entries.
 * 2. If not, use the performance observer.
 * 3. To ensure multiple calls don't confuse things we only ever return the same
 *    Promise instance.
 */ var $6511cc6d783471a6$export$5395fe48d30a6f9b = function() {
    if (!$6511cc6d783471a6$var$paintPerformanceObserverPromise) {
        var performanceEntries = void 0;
        try {
            performanceEntries = performance.getEntriesByType('paint');
        } catch (e) {
            performanceEntries = [];
        }
        if (performanceEntries.length) $6511cc6d783471a6$var$paintPerformanceObserverPromise = Promise.resolve($6511cc6d783471a6$var$normalisePaintPerformanceEntries(performanceEntries));
        else $6511cc6d783471a6$var$paintPerformanceObserverPromise = new Promise(function(resolve, reject) {
            var observer = new PerformanceObserver(function(list) {
                var entries = list.getEntries();
                var normalisedData = $6511cc6d783471a6$var$normalisePaintPerformanceEntries(entries);
                // clean up observer
                observer.disconnect();
                // pass back data
                resolve(normalisedData);
            });
            try {
                observer.observe({
                    entryTypes: [
                        'paint'
                    ]
                });
            } catch (e) {
                reject(e);
            }
        });
    }
    return $6511cc6d783471a6$var$paintPerformanceObserverPromise;
};
var $6511cc6d783471a6$export$d492689e27c62c38 = function() {
    // this is best
    if ('PerformanceObserver' in window) return $6511cc6d783471a6$export$5395fe48d30a6f9b();
    // else
    if ('performance' in window) return new Promise(function(resolve) {
        setTimeout(function() {
            var performanceEntries = performance.getEntriesByType('paint');
            resolve((0, $hXuPC.__spread)(performanceEntries).map($6511cc6d783471a6$var$normaliseData));
        // this ensures we never wait more than TIMEOUT_THRESHOLD
        }, (0, $j9jqV.TIMEOUT_THRESHOLD) - performance.now());
    });
    return Promise.reject(new Error((0, $h8UsG).errors.plugins.paint.unsupported));
};
var $6511cc6d783471a6$export$45b3844926d92e23 = function() {
    var _a = (0, $hXuPC.__read)(performance.getEntriesByName('first-navigation'), 1), firstNavigationMark = _a[0];
    var firstNavTiming = firstNavigationMark && firstNavigationMark.startTime;
    // if no timing exists just use TIMEOUT_THRESHOLD
    return firstNavTiming || (0, $j9jqV.TIMEOUT_THRESHOLD);
};


var $8bb09fda16542e47$var$config = {
    childList: true,
    subtree: true
};
/**
 * High level class instance used to get a best estimate for
 * First Meaningful Paint. By watching the root of the react tree for mutations
 * we can get a fairly good estimate as to when this occurs based on the delta of new nodes.
 */ var $8bb09fda16542e47$export$2e2bcd8739ae039 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(PaintMetricsPlugin, _super);
    /* TODO
    if rootId is not specified, PaintMetrics will still attempt to observe,
    and do nothing presumably - handle this better.
  */ function PaintMetricsPlugin(_a) {
        var _b;
        var _c = _a.rootId, rootId = _c === void 0 ? 'root' : _c, _d = _a.callbacks, callbacks = _d === void 0 ? [] : _d, _e = _a.collectors, collectors = _e === void 0 ? {} : _e, _f = _a.histograms, histograms = _f === void 0 ? {} : _f;
        var _this = _super.call(this, {
            callbacks: callbacks
        }) || this;
        _this.paintTimings = [];
        _this.lastPaintCount = 0;
        _this.histograms = {};
        _this.page = '';
        _this.observer = new MutationObserver(_this.getNewNodes.bind(_this));
        _this.observer.observe(document.getElementById(rootId), $8bb09fda16542e47$var$config);
        if ('PerformanceObserver' in window) (0, $6511cc6d783471a6$export$5395fe48d30a6f9b)().catch((0, (/*@__PURE__*/$parcel$interopDefault($hQNhB))));
        _this.collectors = (0, $hXuPC.__assign)((_b = {}, _b[(0, $lmw9L.PerformanceMetricName).FIRST_MEANINGFUL_PAINT] = _this.getFirstMeaningfulPaintAsync.bind(_this), _b), collectors);
        _this.histograms = histograms;
        // remove observer after TIMEOUT_THRESHOLD
        setTimeout(function() {
            return _this.observer.disconnect();
        }, (0, $j9jqV.TIMEOUT_THRESHOLD));
        return _this;
    }
    /**
   * private function for
   * new node callback
   *
   * @returns {PaintTiming}
   */ PaintMetricsPlugin.prototype.createPaintTimingObject = function() {
        var domSize = document.body.getElementsByTagName('*').length;
        var domCountDelta = domSize - this.lastPaintCount;
        this.lastPaintCount = domSize;
        return {
            time: performance.now(),
            domSize: domSize,
            domCountDelta: domCountDelta
        };
    };
    /**
   * private function for
   * new node callback
   *
   * @returns {void}
   */ PaintMetricsPlugin.prototype.getNewNodes = function() {
        this.paintTimings.push(this.createPaintTimingObject());
    };
    /**
   * Used internall to derive the class's FMP output.
   *
   * @param FCPtiming First Contentful Paint timing
   * @returns {number} The FMP
   */ PaintMetricsPlugin.prototype.getFirstMeaningfulPaint = function(FCPtiming) {
        var firstNavTiming = (0, $6511cc6d783471a6$export$45b3844926d92e23)();
        // omit any timing pre FCP and post first nav
        var usefulTimings = this.paintTimings.filter(function(_a) {
            var time = _a.time;
            return time > FCPtiming && time < firstNavTiming;
        });
        // if there are no timings; FCP === FMP so just return FCP
        if (!usefulTimings.length) return FCPtiming;
        // else we want the _biggest_ layout change that has occurred since FCP
        var _a = (0, $hXuPC.__read)(usefulTimings.sort(function(_a, _b) {
            var b = _a.domCountDelta;
            var a = _b.domCountDelta;
            return a - b;
        }), 1), time = _a[0].time;
        return time;
    };
    PaintMetricsPlugin.prototype.getFirstMeaningfulPaintAsync = function(FCPtiming) {
        var _this = this;
        var DEFER_CALLBACK = (0, $j9jqV.TIMEOUT_THRESHOLD) - performance.now();
        return new Promise(function(resolve) {
            setTimeout(function() {
                return resolve(_this.getFirstMeaningfulPaint(FCPtiming));
            }, DEFER_CALLBACK);
        });
    };
    /**
   * Runs the Paint Metrics plugin.
   *
   * @param client An instance of MetalClient
   */ PaintMetricsPlugin.prototype.install = function(client) {
        this.page = (0, $cVO5G.getPage)(client.pageTracker, true);
        this.callbacks.push((0, $cVO5G.sendMetricTimingCallback)(client));
        this.getTimings();
    };
    /**
   * Destroys the Paint Metrics plugin and its references
   */ PaintMetricsPlugin.prototype.destroy = function() {
        this.observer.disconnect();
    };
    PaintMetricsPlugin.prototype.handleCallbacks = function(_a) {
        var name = _a.name, value = _a.value;
        this.doCallbacks({
            metric: {
                name: name,
                value: value,
                page: this.page
            },
            histograms: this.histograms,
            shouldCheckActiveTab: true
        });
    };
    /**
   * Get the paint timings, and runs the internal callbacks to expose the results to its subscribers.
   */ PaintMetricsPlugin.prototype.getTimings = function() {
        return (0, $hXuPC.__awaiter)(this, void 0, void 0, function() {
            var paints, fcp, name_1, value, e_1;
            return (0, $hXuPC.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, $6511cc6d783471a6$export$d492689e27c62c38)()
                        ];
                    case 1:
                        paints = _a.sent();
                        paints.forEach(this.handleCallbacks.bind(this));
                        fcp = paints.find(function(_a) {
                            var name = _a.name;
                            return name === (0, $lmw9L.PerformanceMetricName).FIRST_CONTENTFUL_PAINT;
                        }).value;
                        name_1 = (0, $lmw9L.PerformanceMetricName).FIRST_MEANINGFUL_PAINT;
                        return [
                            4 /*yield*/ ,
                            this.collectors[name_1](fcp)
                        ];
                    case 2:
                        value = _a.sent();
                        this.handleCallbacks({
                            name: name_1,
                            value: value
                        });
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _a.sent();
                        // TODO: probably give a better annotated error.
                        console.warn('PaintMetricsPlugin: Unable to get Paint Timings');
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return PaintMetricsPlugin;
}((0, $l8YuP.default));
module.exports["default"] = $8bb09fda16542e47$export$2e2bcd8739ae039;

});

parcelRegister("cOeoN", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $hQNhB = parcelRequire("hQNhB");


var $lmw9L = parcelRequire("lmw9L");

parcelRequire("IF0hr");
var $l8YuP = parcelRequire("l8YuP");


var $cVO5G = parcelRequire("cVO5G");





var $ayPUe = parcelRequire("ayPUe");

parcelRequire("8bjcg");
var $h8UsG = parcelRequire("h8UsG");

// TODO: consider re-naming these from 'helpers' to 'collectors / gatherers' something more semantic.
var $7cf629b4e69871b4$export$3eafb634374929f8 = function() {
    return new Promise(function(resolve, reject) {
        if (!window.perfMetrics) reject(new Error((0, $h8UsG).errors.metalhead.notfound));
        if (!Object.prototype.hasOwnProperty.call(window, 'PerformanceLongTaskTiming')) reject(new Error((0, $h8UsG).errors.plugins.interactive.longtask));
        $ayPUe.getFirstConsistentlyInteractive({}).then(resolve);
    });
};
var $7cf629b4e69871b4$export$699ead07e42f063a = function() {
    return new Promise(function(resolve, reject) {
        if (!window.perfMetrics) reject(new Error((0, $h8UsG).errors.metalhead.notfound));
        // onFirstInputDelay's callback also passes delay in ms, and the evt.
        window.perfMetrics.onFirstInputDelay(resolve);
    });
};
var $7cf629b4e69871b4$export$2c8857aae0700d9e = function() {
    return new Promise(function(resolve, reject) {
        try {
            var _a = (0, $hXuPC.__read)(window.performance.getEntriesByType('navigation'), 1), navigationTiming = _a[0];
            if (navigationTiming) /**
         * Navigation Timing Level 2
         * https://www.w3.org/TR/navigation-timing-2/
         * Not supported: IE, Safari
         */ resolve(navigationTiming.responseStart);
            else {
                /**
         * Navigation Timing
         * https://www.w3.org/TR/navigation-timing/
         */ var _b = window.performance.timing, responseStart = _b.responseStart, navigationStart = _b.navigationStart;
                resolve(responseStart - navigationStart);
            }
        } catch (e) {
            // in rare case that navigation timing is not supported
            reject(e);
        }
    });
};


var $953552dc982f3327$var$_a;
var $953552dc982f3327$var$defaultCollectors = ($953552dc982f3327$var$_a = {}, $953552dc982f3327$var$_a[(0, $lmw9L.PerformanceMetricName).FIRST_INPUT_DELAY] = (0, $7cf629b4e69871b4$export$699ead07e42f063a), $953552dc982f3327$var$_a[(0, $lmw9L.PerformanceMetricName).TIME_TO_INTERACTIVE] = (0, $7cf629b4e69871b4$export$3eafb634374929f8), $953552dc982f3327$var$_a[(0, $lmw9L.PerformanceMetricName).TIME_TO_FIRST_BYTE] = (0, $7cf629b4e69871b4$export$2c8857aae0700d9e), $953552dc982f3327$var$_a);
var $953552dc982f3327$export$2e2bcd8739ae039 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(InteractiveMetricsPlugin, _super);
    function InteractiveMetricsPlugin(_a) {
        var _b = _a.callbacks, callbacks = _b === void 0 ? [] : _b, _c = _a.collectors, collectors = _c === void 0 ? {} : _c, _d = _a.histograms, histograms = _d === void 0 ? {} : _d;
        var _this = _super.call(this, {
            callbacks: callbacks
        }) || this;
        _this.histograms = {};
        _this.page = '';
        _this.supportedMetrics = [
            (0, $lmw9L.PerformanceMetricName).FIRST_INPUT_DELAY,
            (0, $lmw9L.PerformanceMetricName).TIME_TO_INTERACTIVE,
            (0, $lmw9L.PerformanceMetricName).TIME_TO_FIRST_BYTE
        ];
        _this.collectors = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, $953552dc982f3327$var$defaultCollectors), collectors);
        _this.histograms = histograms;
        return _this;
    }
    InteractiveMetricsPlugin.prototype.getTimings = function() {
        var _this = this;
        this.supportedMetrics.forEach(function(name) {
            _this.collectors[name]().then(function(value) {
                return _this.doCallbacks({
                    metric: {
                        name: name,
                        value: value,
                        page: _this.page
                    },
                    histograms: _this.histograms,
                    shouldCheckActiveTab: name !== (0, $lmw9L.PerformanceMetricName).FIRST_INPUT_DELAY
                });
            }).catch((0, (/*@__PURE__*/$parcel$interopDefault($hQNhB))));
        });
    };
    InteractiveMetricsPlugin.prototype.install = function(client) {
        this.page = (0, $cVO5G.getPage)(client.pageTracker, true);
        this.callbacks.push((0, $cVO5G.sendMetricTimingCallback)(client));
        this.getTimings();
    };
    return InteractiveMetricsPlugin;
}((0, $l8YuP.default));
module.exports["default"] = $953552dc982f3327$export$2e2bcd8739ae039;

});

parcelRegister("fO1NJ", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");

parcelRequire("IF0hr");
var $l8YuP = parcelRequire("l8YuP");


var $k7lsW = parcelRequire("k7lsW");


var $cVO5G = parcelRequire("cVO5G");




// https://w3c.github.io/resource-timing/#sec-performanceresourcetiming
var $01d6868f1ff52145$export$4725d05bc45951a = [
    'fetch',
    'xmlhttprequest',
    'beacon',
    'other'
];
var $01d6868f1ff52145$export$21bb033bfe5a2706 = [
    // development purposes
    'localhost',
    // anvil (stargate)
    'atlassian.com/metal/ingest',
    // new relic
    'bam.nr',
    // webstatsd ingest
    'webstatsd',
    // GASv3 (stargate)
    'gateway/api/gasv3'
];


/**
 * Used to filter origins that should not be recorded by metal
 */ var $fc95733efe691b59$export$2e2bcd8739ae039 = function(_a) {
    var _b = _a.blacklist, blacklist = _b === void 0 ? [] : _b;
    return function(_a) {
        var resourceName = _a.name;
        return !(0, $hXuPC.__spread)((0, $01d6868f1ff52145$export$21bb033bfe5a2706), blacklist).find(function(origin) {
            return resourceName.includes(origin);
        });
    };
};



var $j9jqV = parcelRequire("j9jqV");


/**
 * Converts a Performance Resource Timing to our own Metric Type
 */ var $1da93073720c2687$export$2e2bcd8739ae039 = function(_a) {
    var initiatorType = _a.initiatorType, duration = _a.duration;
    var name = (0, $01d6868f1ff52145$export$4725d05bc45951a).indexOf(initiatorType) !== -1 ? (0, $j9jqV.BrowserMetricName).REQUEST_TIMING : (0, $j9jqV.BrowserMetricName).RESOURCE_TIMING;
    return {
        name: (0, $j9jqV.BROWSER_METRICS_MAP)[name],
        value: duration,
        type: initiatorType
    };
};


/**
 * Manages sending timings under the broad banner of 'resources'
 *
 * This applies to anything that is accesible in performance.getEntriesByType('resource')
 * and includes.
 *
 * 1. AJAX (Fetch, XHR etc)
 * 2. Assets
 * 3. Other network requests instigated from the DOM.
 */ var $b81cec3274c3569c$export$2e2bcd8739ae039 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(ResourceMetricsPlugin, _super);
    function ResourceMetricsPlugin(_a) {
        var _b = _a.callbacks, callbacks = _b === void 0 ? [] : _b, _c = _a.blacklist, blacklist = _c === void 0 ? [] : _c;
        var _this = _super.call(this, {
            callbacks: callbacks
        }) || this;
        _this.pageTracker = null;
        _this.performance = window.performance;
        _this.timings = [];
        _this.filterEntryList = function(entryList, blacklist) {
            var blackListFilter = (0, $fc95733efe691b59$export$2e2bcd8739ae039)({
                blacklist: blacklist
            });
            return Array.prototype.filter.call(entryList, blackListFilter);
        };
        if (!(0, $k7lsW.isPerformanceObserverSupported)()) {
            console.warn('Metal: Performance Observer not supported, ResourceMetricsPlugin will not work');
            return _this;
        }
        var initialEntryList = _this.performance.getEntriesByType('resource');
        var allowedInitialEntryList = _this.filterEntryList(initialEntryList, blacklist);
        _this.timings = allowedInitialEntryList.map((0, $1da93073720c2687$export$2e2bcd8739ae039));
        // capture future timings
        _this.observer = new PerformanceObserver(function(entries) {
            var _a;
            var entryList = entries.getEntries();
            // important to not get into a recursive loop of sending
            // metrics on network requests stemming from Metal
            var allowedEntryList = _this.filterEntryList(entryList, blacklist);
            var newEntries = allowedEntryList.map((0, $1da93073720c2687$export$2e2bcd8739ae039));
            // capture locally
            _this.timings = (_a = _this.timings).concat.apply(_a, (0, $hXuPC.__spread)(newEntries));
            // send to Metal
            if (newEntries.length) _this.send.apply(_this, (0, $hXuPC.__spread)(newEntries));
        });
        return _this;
    }
    // TODO: this function can probably be removed // call Metal directly
    ResourceMetricsPlugin.prototype.send = function() {
        var _this = this;
        var ajaxResults = [];
        for(var _i = 0; _i < arguments.length; _i++)ajaxResults[_i] = arguments[_i];
        ajaxResults.forEach(function(_a) {
            var name = _a.name, value = _a.value, type = _a.type;
            var page = (0, $cVO5G.getPage)(_this.pageTracker, false);
            _this.doCallbacks({
                metric: {
                    name: name,
                    value: value,
                    type: type,
                    page: page
                }
            });
        });
    };
    /**
   * Runs the Resource Timings plugin.
   *
   * @param client An instance of MetalClient
   */ ResourceMetricsPlugin.prototype.install = function(client) {
        this.pageTracker = client.pageTracker;
        this.callbacks.push((0, $cVO5G.sendMetricTimingCallback)(client));
        this.send.apply(this, (0, $hXuPC.__spread)(this.timings));
        if (this.observer) this.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    };
    /**
   * Destroys the Paint Metrics plugin and its references
   */ ResourceMetricsPlugin.prototype.destroy = function() {
        if (this.observer) this.observer.disconnect();
    };
    return ResourceMetricsPlugin;
}((0, $l8YuP.default));
module.exports["default"] = $b81cec3274c3569c$export$2e2bcd8739ae039;

});

parcelRegister("5vbNx", function(module, exports) {

var $533k0 = parcelRequire("533k0");

var $4018ffda461917a8$export$259b4dd69e654a7a = function(object) {
    return Object.keys(object);
};
var $4018ffda461917a8$export$ad1854f4a08c15f8 = function(object) {
    return $4018ffda461917a8$export$259b4dd69e654a7a(object).map(function(key) {
        return object[key];
    });
};
var $4018ffda461917a8$export$fbac6108fb7c1c58 = function(object) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($533k0)))(object, function(value) {
        return String(value);
    });
};
var $4018ffda461917a8$export$26b9f946b448f23e = function(type, value) {
    return $4018ffda461917a8$export$ad1854f4a08c15f8(type).indexOf(value) > -1;
};
var $4018ffda461917a8$export$94df19ecb868bc1a = function(type, value) {
    return $4018ffda461917a8$export$259b4dd69e654a7a(type).indexOf(value) > -1;
};
module.exports["objectKeys"] = $4018ffda461917a8$export$259b4dd69e654a7a;
module.exports["objectValues"] = $4018ffda461917a8$export$ad1854f4a08c15f8;
module.exports["objectValuesToString"] = $4018ffda461917a8$export$fbac6108fb7c1c58;
module.exports["isType"] = $4018ffda461917a8$export$26b9f946b448f23e;
module.exports["hasKey"] = $4018ffda461917a8$export$94df19ecb868bc1a;

});

parcelRegister("lmw9L", function(module, exports) {
$parcel$export(module.exports, "ErrorMetricName", () => $f8d498a1de9162d5$export$6b0bf32d577cea1d);
$parcel$export(module.exports, "PerformanceMetricName", () => $f8d498a1de9162d5$export$fbc4403eaefe0e15);
$parcel$export(module.exports, "UserInteractionMetricName", () => $f8d498a1de9162d5$export$856052a067eed71b);
var $f8d498a1de9162d5$export$6b0bf32d577cea1d;
(function(ErrorMetricName) {
    /** Page level */ ErrorMetricName["UNCAUGHT"] = "fe.error.uncaught";
    ErrorMetricName["REQUEST"] = "fe.error.request";
    ErrorMetricName["API"] = "fe.error.api";
    ErrorMetricName["GRAPHQL"] = "fe.error.graphql";
    ErrorMetricName["VALIDATION"] = "fe.error.validation";
    ErrorMetricName["INPUT"] = "fe.error.input";
    ErrorMetricName["UNHANDLED_PROMISE_REJECTION"] = "fe.error.unhandledrejection";
    /** Component level */ ErrorMetricName["COMPONENT"] = "fe.error.component";
    ErrorMetricName["COMPONENT_BOUNDARY"] = "fe.error.component.boundary";
    ErrorMetricName["COMPONENT_GRAPHQL"] = "fe.error.component.graphql";
    ErrorMetricName["COMPONENT_API"] = "fe.error.component.api";
})($f8d498a1de9162d5$export$6b0bf32d577cea1d || ($f8d498a1de9162d5$export$6b0bf32d577cea1d = {}));
var $f8d498a1de9162d5$export$fbc4403eaefe0e15;
(function(PerformanceMetricName) {
    /** Page level */ PerformanceMetricName["APDEX"] = "fe.perf.apdex";
    PerformanceMetricName["SPEED_INDEX"] = "fe.perf.speedindex";
    PerformanceMetricName["TIME_TO_INTERACTIVE"] = "fe.perf.time_to_interactive";
    PerformanceMetricName["TIME_TO_INTERACTIVE_SLO"] = "fe.perf.time_to_interactive.slo";
    PerformanceMetricName["TIME_TO_FIRST_BYTE"] = "fe.perf.time_to_first_byte";
    PerformanceMetricName["FIRST_PAINT"] = "fe.perf.first_paint";
    PerformanceMetricName["FIRST_CONTENTFUL_PAINT"] = "fe.perf.first_contentful_paint";
    PerformanceMetricName["FIRST_MEANINGFUL_PAINT"] = "fe.perf.first_meaningful_paint";
    PerformanceMetricName["FIRST_MEANINGFUL_PAINT_SLO"] = "fe.perf.first_meaningful_paint.slo";
    PerformanceMetricName["FIRST_INPUT_DELAY"] = "fe.perf.first_input_delay";
    PerformanceMetricName["REQUEST_TIMING"] = "fe.perf.request_timing";
    PerformanceMetricName["REQUEST_TIMING_SLO"] = "fe.perf.request_timing.slo";
    PerformanceMetricName["RESOURCE_TIMING"] = "fe.perf.resource_timing";
    PerformanceMetricName["CACHE_HITS"] = "fe.perf.cache_hits";
    /** Component level */ PerformanceMetricName["COMPONENT_PREVIEW"] = "fe.perf.component.time_to_preview";
    PerformanceMetricName["COMPONENT_INTERACTIVE"] = "fe.perf.component.time_to_interactive";
    PerformanceMetricName["COMPONENT_READY"] = "fe.perf.component.time_to_ready";
    PerformanceMetricName["COMPONENT_READY_SLO"] = "fe.perf.component.time_to_ready.slo";
    PerformanceMetricName["COMPONENT_REQUEST_TIMING"] = "fe.perf.component.request_timing";
})($f8d498a1de9162d5$export$fbc4403eaefe0e15 || ($f8d498a1de9162d5$export$fbc4403eaefe0e15 = {}));
var $f8d498a1de9162d5$export$856052a067eed71b;
(function(UserInteractionMetricName) {
    UserInteractionMetricName["TASK_SUCCESS"] = "fe.user.task.success";
    UserInteractionMetricName["TASK_FAILURE"] = "fe.user.task.failure";
    UserInteractionMetricName["TASK_DURATION"] = "fe.user.task.duration";
    UserInteractionMetricName["TASK_TIME_TO_FEEDBACK"] = "fe.user.task.time_to_feedback";
    UserInteractionMetricName["TASK_TIME_TO_FEEDBACK_SLO"] = "fe.user.task.time_to_feedback.slo";
    UserInteractionMetricName["TASK_TIME_TO_COMPLETE"] = "fe.user.task.time_to_complete";
    UserInteractionMetricName["TASK_TIME_TO_COMPLETE_SLO"] = "fe.user.task.time_to_complete.slo";
})($f8d498a1de9162d5$export$856052a067eed71b || ($f8d498a1de9162d5$export$856052a067eed71b = {}));

});

parcelRegister("lPHtt", function(module, exports) {
$parcel$export(module.exports, "PayloadType", () => $fe50157f7c4a742b$export$3a0d79760672f45c);
var $fe50157f7c4a742b$export$3a0d79760672f45c;
(function(PayloadType) {
    PayloadType["TIMING"] = "timing";
    PayloadType["GAUGE"] = "gauge";
    PayloadType["INCREMENT"] = "increment";
    PayloadType["DECREMENT"] = "decrement";
})($fe50157f7c4a742b$export$3a0d79760672f45c || ($fe50157f7c4a742b$export$3a0d79760672f45c = {}));

});

parcelRegister("gjsoz", function(module, exports) {

});

parcelRegister("5wdgJ", function(module, exports) {

});

parcelRegister("IF0hr", function(module, exports) {
$parcel$export(module.exports, "Hookable", () => (parcelRequire("fTVVJ")).default);
$parcel$export(module.exports, "CallbackProvider", () => (parcelRequire("l8YuP")).default);

var $fTVVJ = parcelRequire("fTVVJ");


var $l8YuP = parcelRequire("l8YuP");


});

parcelRegister("8bjcg", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("h8UsG")));

var $h8UsG = parcelRequire("h8UsG");


});

parcelRegister("cVO5G", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");

var $96a1a9e1abe8eacf$export$262362f36935fa95 = function(name) {
    return name.split('-').map(function(word) {
        return word.slice(0, 1);
    }).map(function(char) {
        return char.toLowerCase();
    }).join('');
};
var $96a1a9e1abe8eacf$export$28e4c7d8f98d62f4 = function(client) {
    return function(_a) {
        var metric = _a.metric, _b = _a.histograms, histograms = _b === void 0 ? {} : _b, _c = _a.shouldCheckActiveTab, shouldCheckActiveTab = _c === void 0 ? false : _c;
        if (shouldCheckActiveTab) {
            var wasPreviouslyHidden = client.pageVisibility.wasPreviouslyHidden;
            if (wasPreviouslyHidden) return;
        }
        client.metric.submit(metric);
        if (histograms[metric.name]) client.metric.submit((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, metric), {
            histogramBuckets: histograms[metric.name]
        }));
    };
};
var $96a1a9e1abe8eacf$export$c2a6433281518c91 = function(pageTracker, isInitial) {
    if (pageTracker) {
        if (isInitial) return pageTracker.initialPage;
        return pageTracker.page;
    }
    return '';
};
module.exports["sendMetricTimingCallback"] = $96a1a9e1abe8eacf$export$28e4c7d8f98d62f4;
module.exports["getPage"] = $96a1a9e1abe8eacf$export$c2a6433281518c91;

});

parcelRegister("k7lsW", function(module, exports) {
var $ea551cc3aa4a7b88$var$performanceUtils = {
    timeOrigin: performance.timeOrigin || Date.now() - performance.now()
};
var $ea551cc3aa4a7b88$export$155ef68225aaba90 = function() {
    return 'PerformanceObserver' in window && typeof PerformanceObserver === 'function';
};
var $ea551cc3aa4a7b88$export$2e2bcd8739ae039 = $ea551cc3aa4a7b88$var$performanceUtils;
module.exports["isPerformanceObserverSupported"] = $ea551cc3aa4a7b88$export$155ef68225aaba90;

});

parcelRegister("j9jqV", function(module, exports) {
$parcel$export(module.exports, "BrowserMetricName", () => $df0deea1c49ad6de$export$8870cad9441719e8);

var $lmw9L = parcelRequire("lmw9L");

var $df0deea1c49ad6de$var$_a;
// remove observer after 5 seconds
var $df0deea1c49ad6de$export$1e7391fc3454fcbc = 5000;
var $df0deea1c49ad6de$export$8870cad9441719e8;
(function(BrowserMetricName) {
    BrowserMetricName["FIRST_INPUT_DELAY"] = "first-input-delay";
    BrowserMetricName["TIME_TO_INTERACTIVE"] = "time-to-interactive";
    BrowserMetricName["FIRST_CONTENTFUL_PAINT"] = "first-contentful-paint";
    BrowserMetricName["FIRST_MEANINGFUL_PAINT"] = "first-meaningful-paint";
    BrowserMetricName["FIRST_PAINT"] = "first-paint";
    BrowserMetricName["RESOURCE_TIMING"] = "resource-timing";
    BrowserMetricName["REQUEST_TIMING"] = "request-timing";
})($df0deea1c49ad6de$export$8870cad9441719e8 || ($df0deea1c49ad6de$export$8870cad9441719e8 = {}));
/**
 * Maps User metric namespaces to StatsD Metric namespace
 */ var $df0deea1c49ad6de$export$970cb9d7575989f9 = ($df0deea1c49ad6de$var$_a = {}, $df0deea1c49ad6de$var$_a[$df0deea1c49ad6de$export$8870cad9441719e8.FIRST_INPUT_DELAY] = (0, $lmw9L.PerformanceMetricName).FIRST_INPUT_DELAY, $df0deea1c49ad6de$var$_a[$df0deea1c49ad6de$export$8870cad9441719e8.TIME_TO_INTERACTIVE] = (0, $lmw9L.PerformanceMetricName).TIME_TO_INTERACTIVE, $df0deea1c49ad6de$var$_a[$df0deea1c49ad6de$export$8870cad9441719e8.FIRST_CONTENTFUL_PAINT] = (0, $lmw9L.PerformanceMetricName).FIRST_CONTENTFUL_PAINT, $df0deea1c49ad6de$var$_a[$df0deea1c49ad6de$export$8870cad9441719e8.FIRST_PAINT] = (0, $lmw9L.PerformanceMetricName).FIRST_PAINT, $df0deea1c49ad6de$var$_a[$df0deea1c49ad6de$export$8870cad9441719e8.FIRST_MEANINGFUL_PAINT] = (0, $lmw9L.PerformanceMetricName).FIRST_MEANINGFUL_PAINT, $df0deea1c49ad6de$var$_a[$df0deea1c49ad6de$export$8870cad9441719e8.REQUEST_TIMING] = (0, $lmw9L.PerformanceMetricName).REQUEST_TIMING, $df0deea1c49ad6de$var$_a[$df0deea1c49ad6de$export$8870cad9441719e8.RESOURCE_TIMING] = (0, $lmw9L.PerformanceMetricName).RESOURCE_TIMING, $df0deea1c49ad6de$var$_a);
module.exports["TIMEOUT_THRESHOLD"] = $df0deea1c49ad6de$export$1e7391fc3454fcbc;
module.exports["BROWSER_METRICS_MAP"] = $df0deea1c49ad6de$export$970cb9d7575989f9;

});

parcelRegister("h8UsG", function(module, exports) {
var $c7aefb1e1dc8394b$export$30f3b02011db23c0 = {
    metalhead: {
        notfound: "Metal: For TTI & FID metrics,\n      you should include metal-head.min.js within <head>\n      to setup observers and timings as early as possible."
    },
    metrics: {
        browser: {
            rootId: "Metal: Browser Metrics:\n        rootId must be supplied to instantiate this plugin"
        }
    },
    metalClient: {
        metalId: "Metal: Deprecation warning:\n      Metal will require a metalId to determine config in future versions.\n      Please update your client's config."
    },
    plugins: {
        paint: {
            unsupported: 'Metal: Performance Painting Timings: not supported by this browser'
        },
        interactive: {
            longtask: 'Metal: Long task not supported'
        }
    }
};
module.exports["errors"] = $c7aefb1e1dc8394b$export$30f3b02011db23c0;

});


//# sourceMappingURL=es.f2e06647.js.map
